import { Component } from '@angular/core';
import { NavController, LoadingController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { DetailAdvPage, AdvEmployeePage } from '../';
import { User, Master, Advance } from '@providers/advance_providers';

@Component({
  selector: 'page-home',
  templateUrl: 'page.html'
})
export class UserAdvPage {

  user:any={};
  params:any={};
  list:any=[];
  total_amount = 0;
  currency = '';
  employee:any=[];
  akses:any=[];

  constructor(
    public navCtrl    : NavController,
    public masterApi  : Master,
    public userApi    : User,
    public advanceApi : Advance,
    public loadingCtrl: LoadingController,
    public toastCtrl  : ToastController,
    public navParams  : NavParams,
    public alertCtrl  : AlertController
    ) {
    
    this.akses = this.userApi.akses;
    this.user = this.userApi.data;
    this.params = {
      user_nik     : this.user.user_nik
    }
    this.getList();
    console.log('akses => ', this.akses);
    console.log('user data => ', this.user);
  }

  doRefresh(refresher){
    refresher.complete();
    this.getList();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message : msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
  
  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params: any = this.params;
    this.advanceApi.get(params).subscribe((resp:any) => {
      if (resp.data!=''){
        this.list = resp.data;
        this.total_amount = resp.total_amount.total_amount;
        this.currency = resp.data[0].currency;

        loading.dismiss();
      }else{
        this.presentToast("Anda tidak memiliki data outstanding Advance");
        loading.dismiss();
      }
    }, (err) => {
      loading.dismiss();
    });
  }

  toAdvanceAll(){
    this.navCtrl.push(AdvEmployeePage,{
      user_nik     : this.user.user_nik,
      employee_id  : this.user.employee_id,
      employee_name: this.user.user_name 
    });
  }

  toDetailAdvance(id, item){
    this.navCtrl.push(DetailAdvPage, {
      id:id,
      item:item
    });
  }

  localFormating(v){
    v = parseFloat(v);
    v = v.toLocaleString(['ban', 'id']);
    if(v=='NaN'){
      v='-';
    }
    return v;
  }

}



// WEBPACK FOOTER //
// ./src/pages/advance_mobile/user_adv/page.ts